import * as ApiManager from './_manager'
import store from '../store';


export const tag = {
    list: (payload) => {
        return ApiManager.callApi(`/member/company/${store.getters['company/getSelected']}/tag/all/list`, payload);
    },
    listCountries: (payload) => {
        return ApiManager.callApi(`/config/country/list`, payload);
    },
    //Todo: Now available on film
    getTags: (payload) => {
        return ApiManager.callApi(`/member/company/${store.getters['company/getSelected']}/tag/model/getTags`, payload);
    }
}
